const getters ={
    // user: state => state.user,
    // getTabList: state => state.user.tabList,
}
export default getters;